import { GridToolbarContainer } from '@mui/x-data-grid'
import React from 'react'
import { ProjectSearchForm, ProjectSearchFormValues } from './ProjectSearchForm'

type Props = {
  searchFormDefaultValues: ProjectSearchFormValues
  onSearchFormSubmit: (values: ProjectSearchFormValues) => void
  disabled: boolean
}

export function ProjectListGridToolbar({
  searchFormDefaultValues,
  onSearchFormSubmit,
  disabled,
}: Props): React.ReactElement {
  return (
    <GridToolbarContainer>
      <ProjectSearchForm
        defaultValues={searchFormDefaultValues}
        onSubmit={onSearchFormSubmit}
        disabled={disabled}
      />
    </GridToolbarContainer>
  )
}
